import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

type PlanTasksModalTab = 'tasks' | 'pmRouteData';

@Component({
  selector: 'app-plan-tasks-modal',
  templateUrl: './plan-tasks-modal.component.html',
  styleUrls: ['./plan-tasks-modal.component.scss'],
})
export class PlanTasksModalComponent {
  @Input() planId = 0;
  @Input() planTitle = '';
  @Input() showReleasedVersionOnly = false;

  activeTab: PlanTasksModalTab = 'tasks';

  constructor(public bsModalRef: BsModalRef) {}

  tabChange(tab: PlanTasksModalTab): void {
    this.activeTab = tab;
  }
}
